const marketTestInboxes = [
    {
        "uuid": "1",
        "createdOn": "2021-10-01T08:00:00.000Z",
        "appNo": "A21100111",
        "activity": "marketTest_S10",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "台東廠",
        "product": "杏仁玄米餅",
        "remainingDays": "",
        "source": "plan",
        "testResults":[
            {
                "testItems":[{"testItem":"11"}]
            },
            {
                "testItems":[{"testItem":"01"},{"testItem":"02", "details":["0201","0202"]}]
            }
        ],
    },
    {
        "uuid": "2",
        "createdOn": "2021-10-01T08:00:00.000Z",
        "appNo": "A21100112",
        "activity": "marketTest_S10",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "台東廠",
        "product": "桂圓四物飲",
        "remainingDays": "",
        "source": "plan",
        "testResults":[
            {
                "testItems":[{"testItem":"11"}]
            },
            {
                "testItems":[{"testItem":"01"},{"testItem":"02", "details":["0201","0202"]}]
            }
        ],
    },
    {
        "uuid": "3",
        "createdOn": "2021-10-01T08:00:00.000Z",
        "appNo": "A21100113",
        "activity": "marketTest_S10",
        "customerNo": "0002",
        "customerName": "聯華製粉食品股份有限公司",
        "assessmentPlace": "桃園廠",
        "product": "Posta義大利麵",
        "remainingDays": "",
        "source": "plan",
        "testResults":[
            {
                "testItems":[{"testItem":"11"}]
            },
            {
                "testItems":[{"testItem":"01"},{"testItem":"02", "details":["0201","0202"]}]
            }
        ],
    },
    {
        "uuid": "4",
        "createdOn": "2021-12-02T08:00:00.000Z",
        "appNo": "A21100102",
        "activity": "marketTest_S20",
        "customerNo": "0003",
        "customerName": "揚明食品有限公司",
        "assessmentPlace": "桃園廠",
        "product": "蜜汁馬鈴薯",
        "remainingDays": "",
        "source": "selfAdd",
        "testResults":[
            {
                "testItems":[{"testItem":"11"}]
            },
            {
                "testItems":[{"testItem":"01"},{"testItem":"02", "details":["0201","0202"]}]
            }
        ],
        "packingMethod": "glassBottle",
        "packagingSpec": "360ml/瓶",
        "samplingLocation": "開心農場",
        "samplingDate": "2022-01-03T00:00:00.000Z",
        "effectiveDate": "2023-01-03T00:00:00.000Z",
        "testCompany": "sgs",
        "paymentUnit": "leezen",
    },
]

export default marketTestInboxes;